import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Filter = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M17.7608 5.5H6.23964C4.91951 5.5 4.60268 6.16606 5.53685 6.98126L10.5601 11.3647V18.0673C10.5601 18.5281 10.8654 18.6386 11.2389 18.3127L12.7616 16.984C13.135 16.658 13.4404 16.0146 13.4404 15.5538V11.3647L18.4636 6.98126C19.3968 6.16606 19.0809 5.5 17.7608 5.5Z"
        />
    </StarryUIIcon>
);
